import React from 'react'
import { components } from 'react-select'

const DefaultSingleValue = (props) => <components.SingleValue {...props} />

export { DefaultSingleValue }
